import './DataEntryWrapper.less';

export const prefix = 'bm-c-data-entry';

export { default } from './DataEntryWrapper';
